if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // Get product data from the page
        this.productData = this.getProductData();

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Listen for variant changes
        this.setupVariantChangeListener();
      }

      getProductData() {
        // Try to get product data from various sources
        let productData = null;

        // Method 1: From script tag with type="application/json"
        const productScript = document.querySelector('script[type="application/json"][data-product-json]');
        if (productScript) {
          try {
            productData = JSON.parse(productScript.textContent);
          } catch (e) {
            console.warn('Could not parse product JSON from script tag');
          }
        }

        // Method 2: From window object (common in many themes)
        if (!productData && window.product) {
          productData = window.product;
        }

        // Method 3: From meta tag
        if (!productData) {
          const productMeta = document.querySelector('meta[name="product"]');
          if (productMeta) {
            try {
              productData = JSON.parse(productMeta.content);
            } catch (e) {
              console.warn('Could not parse product JSON from meta tag');
            }
          }
        }

        return productData;
      }

      setupVariantChangeListener() {
        // Listen for changes on the variant selector
        const variantSelector = this.form.querySelector('[name=id]');
        if (variantSelector) {
          variantSelector.addEventListener('change', () => {
            this.logCurrentVariant();
          });
        }

        // Also listen for any variant picker changes (radio buttons, selects, etc.)
        const variantInputs = this.form.querySelectorAll('input[name^="option"], select[name^="option"]');
        variantInputs.forEach(input => {
          input.addEventListener('change', () => {
            // Small delay to ensure variant ID is updated
            setTimeout(() => {
              this.logCurrentVariant();
            }, 100);
          });
        });
      }

      getCurrentVariant() {
        const selectedVariantId = this.form.querySelector('[name=id]').value;

        if (!selectedVariantId || !this.productData) {
          return null;
        }

        // Find the variant in the product data
        const variant = this.productData.variants.find(v => v.id == selectedVariantId);
        return variant;
      }

      logCurrentVariant() {
        const variant = this.getCurrentVariant();

        // if (variant) {
        //   console.log('Current Variant Details:', {
        //     id: variant.id,
        //     title: variant.title,
        //     price: variant.price,
        //     compare_at_price: variant.compare_at_price,
        //     available: variant.available,
        //     inventory_quantity: variant.inventory_quantity,
        //     sku: variant.sku,
        //     weight: variant.weight,
        //     option1: variant.option1,
        //     option2: variant.option2,
        //     option3: variant.option3,
        //     featured_image: variant.featured_image
        //   });
        // } else {
        //   console.log('No variant selected or product data not available');
        // }
      }

      // Method to get current variant for external use (like your sticky add to cart)
      getSelectedVariantData() {
        return this.getCurrentVariant();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Log the variant being added to cart
        this.logCurrentVariant();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        // Check for skip cart setting
        this.skipCart = false;
        if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
          this.skipCart = true;
        }

        if (this.cart && !this.skipCart) {
          this.cart.setActiveElement(document.activeElement);
        }

        // Build items array: bundle items first, then main product
        const bundleVariantId = this.dataset.bundleVariantId;
        const bundleVariantId2 = this.dataset.bundleSecondVariantId;
        const bundleSellingPlan = this.dataset.bundleSellingPlan;
        const currentUpsellId = this.dataset.upsellVariantId;
        const self = this;
        const mainVariantId = this.form.querySelector('[name=id]').value;
        const mainQuantity = this.form.querySelector('[name=quantity]')?.value || 1;

        const buildAndAdd = async () => {
          const items = [];

          // Check cart for existing bundle items
          let cartState = { items: [] };
          if (bundleVariantId || bundleVariantId2 || currentUpsellId) {
            try {
              const cartRes = await fetch(`${routes.cart_url}.js`);
              cartState = await cartRes.json();
            } catch (e) { }
          }

          // Main product first
          const mainItem = { id: parseInt(mainVariantId), quantity: parseInt(mainQuantity) };
          const sellingPlanInput = self.form.querySelector('[name=selling_plan]');
          if (sellingPlanInput && sellingPlanInput.value) {
            mainItem.selling_plan = parseInt(sellingPlanInput.value);
          }
          items.push(mainItem);

          // Bundle 1: membership
          if (bundleVariantId && !cartState.items.some(item => item.variant_id == bundleVariantId)) {
            const bundleItem = { id: parseInt(bundleVariantId), quantity: 1 };
            if (bundleSellingPlan) bundleItem.selling_plan = parseInt(bundleSellingPlan);
            items.push(bundleItem);
          }

          // Bundle 2: socks
          if (bundleVariantId2 && !cartState.items.some(item => item.variant_id == bundleVariantId2)) {
            items.push({ id: parseInt(bundleVariantId2), quantity: 1 });
          }

          // Upsell
          if (currentUpsellId && !cartState.items.some(item => item.variant_id == currentUpsellId)) {
            items.push({ id: parseInt(currentUpsellId), quantity: 1 });
          }

          // Single request to add all items
          const cfg = fetchConfig('javascript');
          cfg.headers['Content-Type'] = 'application/json';
          cfg.body = JSON.stringify({ items });

          // Add sections for cart drawer
          if (self.cart && !self.skipCart) {
            const sectionsUrl = window.location.pathname;
            cfg.body = JSON.stringify({
              items,
              sections: self.cart.getSectionsToRender().map(s => s.id),
              sections_url: sectionsUrl
            });
          }

          const response = await fetch(`${routes.cart_add_url}`, cfg);
          return response.json();
        };

        const addProductPromise = buildAndAdd();

        // Process main product add
        addProductPromise
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            // Change button text to "Added!" and revert after 2 seconds
            const buttonTextSpan = this.submitButton.querySelector('span');
            if (buttonTextSpan) {
              const originalText = buttonTextSpan.innerHTML;
              buttonTextSpan.textContent = 'Added!';

              setTimeout(() => {
                buttonTextSpan.innerHTML = originalText;
              }, 2000);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Instant feedback - no artificial delay
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getUpsellProductConfig(variantId) {
        const upsellFormData = new FormData();
        upsellFormData.append('id', variantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
